import { BaseAdvancedFilters } from "./BaseAdvancedFilters";

export class BooleanAFilter extends BaseAdvancedFilters {
    protected override _constructor(): void {
        super._constructor();

        this.addItems([
            { value: true, id: "[values]", lockey: "GUI-146844", valueType: "boolean_list" },
            { value: false, id: "[values]", lockey: "GUI-146846", valueType: "boolean_list" },
            null,
            { value: "NULL", id: "is_empty", lockey: "GUI-487654", valueType: "boolean_list" },
            { value: "NULL", id: "is_not_empty", lockey: "GUI-487656", valueType: "boolean_list" },
        ]);
    }
}
